<template>
  <TopApp />
  <div class="app-content">
    <FilterApp />
    <slot />
  </div>
</template>

<script>
import TopApp from '@/views/vehicles/components/TopApp.vue';
import FilterApp from '@/views/vehicles/components/FilterApp.vue';

export default {
  name: "VehicleBaseLayout",
  data (){
    return {
      name: undefined
    }
  },
  components: {
    TopApp,
    FilterApp,
  },
};
</script>
